import {
  HEX_000000,
  HEX_273D58,
  HEX_292D38,
  HEX_68727F,
  HEX_ADB5C7,
  HEX_ECF4FF,
} from '@tanium/colors';
import { getRgbString } from '@tanium/coreui-utils';
import { Background1, Border1, defineColor, defineShadow } from '@tanium/react-theme-definition';

export const ContainerFill = Background1;
export const ContainerBorder = Border1;
export const ContainerShadow = defineShadow([
  `0 4px 10px ${getRgbString(HEX_292D38, '30%')}`,
  `0 2px 6px ${getRgbString(HEX_000000, '56%')}`,
]);

export const ItemFillHover = defineColor([HEX_ECF4FF, HEX_273D58]);
export const ItemDisabledText = defineColor([HEX_ADB5C7, HEX_68727F]);
